import { CompanyController } from "@/app/core/base/controllers/CompanyController";
import { Autocomplete } from "@/app/core/util/helpers/AutocompleteHelper";
import { CompanyHelper } from "@/app/core/util/helpers/CompanyHelper";
import useDebounce from "@/app/core/util/helpers/DebounceHelper";
import { CnpjMask } from "@/app/core/util/helpers/FieldHelper";
import React, { useEffect, useState } from "react";

export default function CompanySearch({
  onSelect,
  onFullSelection,
  hideRegister,
}) {
  const [companies, setCompanies] = useState([]);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    query: "",
  });
  const debouncedData = useDebounce(data, 500);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (debouncedData) {
      executeSearch();
    }
  }, [debouncedData]);

  function loadData() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    // CompanyController.List({ status: CompanyHelper.Status.Approved }).then(
    //   (results) => {
    //     for (let r of results) {
    //       r.searchName = `${r.name} ${
    //         r.website != undefined ? `Site: ${r.website}` : ""
    //       }`;
    //     }
    //     console.log("Companies", results);
    //     setCompanies(results);
    //   }
    // );
  }

  function onSearchTextChanged(value) {
    setData({ ...data, query: value });
  }

  async function executeSearch() {
    if (window.location.href.includes("reclamar")) {
      window.scroll({
        top: 130,
        left: 0,
        behavior: "smooth",
      });
    } else {
      // window.scroll({
      //   top: 200,
      //   left: 0,
      //   behavior: "smooth",
      // });
    }

    try {
      let queryString = debouncedData.query || "";
      if (queryString && queryString !== "") {
        let results = await CompanyController.Query({
          queryString: queryString,
          hitsPerPage: 25,
        });

        for (let c of results) {
          c.searchName = `${c.name}`;
          // c.searchName = `${c.name} ${
          //   c.website != undefined ? `Site: ${c.website}` : ""
          // }`;
        }

        // companiesResult = Autocomplete(queryString, results, ["searchName"]);
        console.log("Resultados", queryString, results);
        setResults(results.filter(x => x.verified === true));
      } else {
        setResults([]);
      }
    } catch (error) {}
  }

  function onItemSelected(dataObj) {
    setResults([]);
    setData({ ...data, query: dataObj.searchName });
    if (!onFullSelection) {
      onSelect(dataObj.id);
    } else {
      onFullSelection(dataObj);
    }
  }

  function newCompany() {
    window.location = `#/reclamar/?newCompany=${data.query}`;
    window.location.reload();
  }

  function scrollDown(){
    window.scroll({
        top: 200,
        left: 0,
        behavior: "smooth",
      });
  }

  return (
    <div id="baseDiv">
      <div className="form-group">
        <input
          className="form-control form-control-lg"
          value={data && data.query}
          onChange={(evt) => onSearchTextChanged(evt.target.value)}
          onClick={() => scrollDown()}
          placeholder="Pesquise a Empresa"
        />
      </div>

      {data && data.query && data.query.length >= 3 ? (
        <div
          className="block block-rounded m-0 block-bordered"
          style={{ zIndex: 99999999999 }}
        >
          {loading === true ? (
            <div className="text-center">
              <i className="fa fa-2x fa-circle-notch fa-spin text-info py-3" />
            </div>
          ) : (
            <div className="m-2">
              <table className="table table-borderless table-hover">
                {results && results.length > 0 ? (
                  <tbody className="mb-0 pb-0">
                    {results &&
                      results.map((item, index) => (
                        <tr
                          onClick={() => onItemSelected(item)}
                          className="text-left mb-0 pb-0 border-bottom"
                        >
                          <td className="">
                            <h3 className="cursor">{item.searchName}</h3>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                ) : (
                  ""
                )}
              </table>
              {hideRegister === undefined ? (
                <div className="text-center">
                  <button
                    className="btn btn-outline-warning text-dark"
                    onClick={() => newCompany()}
                  >
                    Não Encontrou a empresa? Cadastre
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
